import classNames from 'classnames/bind';

import styles from './Confidea.module.scss';
import { LeftChervonIcon, PersonBoardIcon, RightChervonIcon } from '../Icons/Icons';
import images from '~/assets/images';

import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Autoplay, Pagination, Navigation, Keyboard } from 'swiper';

const cx = classNames.bind(styles);

function Confidea() {
    return (
        <div className={cx('wrapper')}>
            <div className={cx('inner')}>
                <div className={cx('header')}>
                    <h1>CHIA SẺ MỘT CHÚT...</h1>
                </div>
                <div className={cx('content', 'grid')}>
                    <div className={cx('talk', 'row')}>
                        <div className={cx('right', 'col', 'p-9-5')}>
                            <div className={cx('des_right')}>
                                <p>
                                    Hi there, mình là một sinh viên Điện tử - Viễn thông, trái ngành sinh năm 2001 học
                                    Viễn thông - Bách khoa đó mấy bạn. Các bạn có thấy câu chuyện này giống với câu
                                    chuyện nào đó không,... Đúng rồi đó, nhưng mình còn thiếu mỗi nhà, mỗi đất, mỗi xe
                                    thôi!
                                </p>
                            </div>
                            {/* <audio controls autoPlay src={audio._96bachkhoa}></audio> */}
                            <div className={cx('des_right')}>
                                <p>
                                    Hì nói đùa thế thôi chứ mình biết xuất phát điểm của mình không phải là dân IT,
                                    thành ra những kiến thức cơ bản mình bắt buộc phải tự trau dồi, cũng từ điều này cho
                                    mình nhìn nhận được khả năng tự học, rèn luyện tính kỷ luật và lâu dần cũng quen,
                                    một viễn cảnh trong tương lai khi mình đạt được mục tiêu đã đề ra thì đó sẽ là động
                                    lực bước tiếp của mình.
                                </p>
                            </div>
                            {/* <div className={cx('video_comedy')}>
                                <video src={videos._96bachkhoa} controls autoPlay></video>
                            </div> */}
                        </div>
                    </div>
                    <div className={cx('famous-quote')}>
                        <div className={cx('title')}>
                            <h2 className={cx('h2')}>Các câu nói mình tâm đắc</h2>
                            <div className={cx('icon', 'book-color')}>
                                <PersonBoardIcon />
                            </div>
                        </div>

                        <Swiper
                            keyboard={{
                                enabled: true,
                            }}
                            spaceBetween={30}
                            centeredSlides={true}
                            autoplay={{
                                delay: 5000,
                                disableOnInteraction: false,
                            }}
                            loop
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                },
                                720: {
                                    slidesPerView: 1.3,
                                },
                                1024: {
                                    slidesPerView: 1.2,
                                },
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            navigation={true}
                            modules={[Keyboard, Autoplay, Pagination, Navigation]}
                            className="mySwiper"
                        >
                            <SwiperSlide>
                                <div className={cx('des')}>
                                    <div className={cx('caccaunoi-inner')}>
                                        <div className={cx('image-content')}>
                                            <img src={images.danglenguyenvu} alt="Đặng Lê Nguyên Vũ" />
                                        </div>
                                        <div className={cx('name-and-des')}>
                                            <h2>Đặng Lê Nguyên Vũ</h2>
                                            <p>
                                                "Không dám nghĩ lớn, và nếu thấy người khác nghĩ lớn thì chê bai, ganh
                                                ghét. Thử hỏi nghĩ còn không dám thì làm sao anh nói chuyện hành động."
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className={cx('des')}>
                                    <div className={cx('caccaunoi-inner')}>
                                        <div className={cx('image-content')}>
                                            <img src={images.einstein} alt="Albert Einstein" />
                                        </div>
                                        <div className={cx('name-and-des')}>
                                            <h2>Albert Einstein</h2>
                                            <p>"Đừng cố gắng làm người thành công, hãy cố gắng làm người có ích!"</p>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className={cx('des')}>
                                    <div className={cx('caccaunoi-inner')}>
                                        <div className={cx('image-content')}>
                                            <img src={images.thomasedison} alt="Thomas Edison" />
                                        </div>
                                        <div className={cx('name-and-des')}>
                                            <h2>Thomas Edison</h2>
                                            <p>
                                                "Điểm yếu lớn nhất của chúng ta nằm ở việc bỏ cuộc. Cách chắc chắn nhất
                                                để thành công là luôn luôn thử thêm một lần nữa."
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className={cx('des')}>
                                    <div className={cx('caccaunoi-inner')}>
                                        <div className={cx('image-content')}>
                                            <img src={images.thayminhniem} alt="Thầy Minh Niệm" />
                                        </div>
                                        <div className={cx('name-and-des')}>
                                            <h2>Thầy Minh Niệm</h2>
                                            <p>"Tình yêu được tạo ra từ những thứ không phải là tình yêu"</p>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <div className="swiper-button-next btn-wrapper btn-confidia">
                                <button className="swiper_btn">
                                    <RightChervonIcon className="swiper_btn-icon" />
                                </button>
                            </div>
                            <div className="swiper-button-prev btn-wrapper btn-confidia">
                                <button className="swiper_btn">
                                    <LeftChervonIcon className="swiper_btn-icon" />
                                </button>
                            </div>
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Confidea;
